// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__5xd0r","selected":"Chip_selected__1XlHt"};